export const COURSE_PRICES = {
  "ccna": "$300",
  "ccnp-encor": "$400",
  "ccnp-enarsi": "$400",
  "palo-alto": "$400",
  "fortigate": "$400",
  "f5-ltm": "$400",
  "sd-wan": "$500",
  "checkpoint": "$400",
  "asa-ftd": "$400",
  "ccnp-security": "$400",
  "mcsa": "$300",
  "azure-900": "$200",
  "azure-104": "$300",
  "azure-700": "$400",
  "azure-500": "$400",
  "azure-400": "$400",
  "aws-practitioner": "$200",
  "aws-saa": "$300",
  "aws-networking": "$400",
  "aws-security": "$400",
  "linux-kali": "$300",
  "ceh-v13": "$400",
  "comptia-security-plus": "$400",
  "comptia-pentest-plus": "$400",
  "cissp": "$1000",
  "oscp": "$1000",
  "ai-fundamentals": "$300",
  "ml-python": "$400",
  "ai-network-engineers": "$400",
  "ai-cloud-engineers": "$500",
  "ai-cyber-security": "$500",
  "genai-llm": "$500",
};
